import React from 'react';
import { Input } from '@shadcn/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shadcn/components/ui/select';
import { Button } from '@shadcn/components/ui/button';
import { X } from 'lucide-react';
import { OPERATORS, OPERATOR_LABELS, OPERATORS_BY_TYPE } from '../../../constants';
import FieldPicker from './FieldPicker';

// Operators that don't take a comparison value
const VALUE_LESS_OPERATORS = [OPERATORS.IS_NULL, OPERATORS.IS_NOT_NULL];

const ConditionRowEditor = ({ condition, onChange, onRemove, fields = [] }) => {
  const update = (field, value) => {
    onChange({ ...condition, [field]: value });
  };

  const needsValue = !VALUE_LESS_OPERATORS.includes(condition.operator);

  const handleFieldSelect = (path, type) => {
    const newCondition = { ...condition, field: path };
    // Reset operator if it's no longer valid for the new field type
    if (type) {
      const allowedOps = OPERATORS_BY_TYPE[type];
      if (allowedOps && condition.operator && !allowedOps.includes(condition.operator)) {
        newCondition.operator = '';
      }
    }
    onChange(newCondition);
  };

  // Derive which operators to show based on the selected field's type
  const fieldDef = fields.find((f) => f.path === condition.field);
  const fieldType = fieldDef?.type;
  const availableOperators = fieldType && OPERATORS_BY_TYPE[fieldType]
    ? OPERATORS_BY_TYPE[fieldType]
    : Object.values(OPERATORS);

  return (
    <div className="flex items-center gap-1.5 group">
      <FieldPicker
        value={condition.field || ''}
        onChange={handleFieldSelect}
        fields={fields}
      />
      <Select
        value={condition.operator || ''}
        onValueChange={(val) => {
          const changes = { ...condition, operator: val };
          // Clear value when switching to an operator that doesn't need one
          if (VALUE_LESS_OPERATORS.includes(val)) {
            changes.value = undefined;
          }
          onChange(changes);
        }}
      >
        <SelectTrigger className="w-[130px] h-8 text-xs shrink-0">
          <SelectValue placeholder="operator" />
        </SelectTrigger>
        <SelectContent>
          {availableOperators.map(op => (
            <SelectItem key={op} value={op} className="text-xs">
              {OPERATOR_LABELS[op]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {needsValue && (
        <Input
          value={condition.value !== undefined ? condition.value : ''}
          onChange={(e) => update('value', e.target.value)}
          placeholder="value"
          className="flex-1 h-8 text-xs min-w-0"
        />
      )}
      {onRemove && (
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity text-gray-400 hover:text-red-500"
          onClick={onRemove}
        >
          <X size={14} />
        </Button>
      )}
    </div>
  );
};

export default ConditionRowEditor;
